import React from "react";
import CardContent from "./CardContent";
import SnapForm,
{ SNAPCHAT_CAROUSEL_STORY_SNAP_FORM_FIELDS as FROM_FIELDS } from "./SnapchatCarouselStorySnapForm";

export const SNAPCHAT_CAROUSEL_STORY_SNAPS_FIELDS = {
	cards: { ...FROM_FIELDS },
};

export default function SnapchatCarouselStorySnapsSection(props){
	const {
		libraryId,
		navigationActions,
		isViewOnly,
		showPristineErrors,
		doVersionsExist,
		adType,
	} = props;
	return (
		<CardContent
			libraryId={libraryId}
			adType={adType}
			isViewOnly={isViewOnly}
			showPristineErrors={showPristineErrors}
			navigationActions={navigationActions}
			CardForm={SnapForm}
			doVersionsExist={doVersionsExist}
			customHeadingDesctiption="STORY SNAPS"
			extraCardHeaderProps={{ title: "SNAP" }}
		/>
	);
}
